(() => {
 const format = () => document.querySelectorAll('.zoka-description-body:not([data-copy-formatted])').forEach(root => {
  root.dataset.copyFormatted = 'true';
  const notes = [];
  root.querySelectorAll('.note-tooltip').forEach(note => {
   const text = note.querySelector('.js-tooltip-descriptor, .visually-hidden')?.textContent.trim();
   if (!text) return;
   if (!notes.includes(text)) notes.push(text);
   const ref = document.createElement('sup');
   ref.textContent = '[' + (notes.indexOf(text) + 1) + ']';
   note.replaceWith(ref);
  });
  if (notes.length) {
   const details = document.createElement('details');
   details.className = 'zoka-description-notes';
   const summary = document.createElement('summary');
   summary.textContent = document.documentElement.lang.startsWith('ar') ? 'ملاحظات المواصفات' : 'Specification notes';
   const list = document.createElement('ol');
   notes.forEach(text => { const item = document.createElement('li'); item.textContent = text; list.append(item); });
   details.append(summary, list); root.append(details);
  }
  root.querySelectorAll('[style]').forEach(el => {
   ['font-family','font-size','color','line-height'].forEach(p => el.style.removeProperty(p));
  });
  root.querySelectorAll('table').forEach(table => {
   if (table.parentElement.classList.contains('zoka-description-table')) return;
   const wrap = document.createElement('div'); wrap.className = 'zoka-description-table';
   table.before(wrap); wrap.append(table);
  });
  root.querySelectorAll('iframe[width][height]').forEach(frame => {
   const w = Number(frame.getAttribute('width')), h = Number(frame.getAttribute('height'));
   if (w > 0 && h > 0) { frame.style.aspectRatio = w + '/' + h; frame.style.width = '100%'; frame.style.height = 'auto'; if (h>w) frame.style.maxWidth='380px'; }
  });
 });
 if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', format, {once:true}); else format();
 document.addEventListener('shopify:section:load', format);
})();